import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import CvPage from "./cv/CvPage";
import AdminApp from "./admin/AdminApp";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CvPage />} />
          <Route path="/admin" element={<AdminApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
